export default __webpack_public_path__ + "media/SideBySide.a17702ab.png";